import { createContext } from 'react';

interface TitleContextState {
  compact: boolean;
}

export const defaultTileContext: TitleContextState = { compact: false };

export const TileContext = createContext<TitleContextState>(defaultTileContext);

const { Provider } = TileContext;

export { Provider as TileContextProvider };
